import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, iRootState } from '../redux/store';

const LoadFortisConfig = function LoadFortisConfig(): null {
  const dealerId = useSelector((state: iRootState) => state.quote.dealerId);
  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    if (dealerId) {
      dispatch.fortis.getConfig(dealerId);
    }
  }, [dispatch.fortis, dealerId]);

  return null;
};

export default LoadFortisConfig;
